export const UID = "1101944";
export const VIN = "L4NSPGHBXLA004322";
export const VIN2 = "LMVHFEFZ0HA600188";
export const siyuanVINPre = "L1NSPGHB2LA011464";
export const UID2 = "1102141";
export const siyuanUid = "1097538";
export const siyuanUid2 = "1102208";
export const siyuanUidPre = "7802966";
export const fangmingUid = "1152645";
export const fangmingUid2 = "1102021";
export const zsUid = "1101944";

export const CAR_INFO = {
  // plateNo: '',
  // relationType: 1,
  // vehicleTypeCode: 'EA',
  // vin: 'L4NSPGHBXLA004322'
  vin: VIN2,
  platenum: ""
};

export const LOGIN_STATE = {
  username: "",
  mobile: "",
  uid: zsUid
};

export const LOCATION = {
  adCode: "440106",
  address: "广东省广州市天河区新塘街道智慧园 12312312",
  cityCode: "020",
  coords: {
    latitude: 23.16499913194444443,
    longitude: 113.40893527560763
  }
};
